import { GetRESTData, getBaseSearchURL, getDigest, RemoveSpecialCharsFromQuery} from "../../utils/searchHelpers";
import IRefiners from "../../Models/IRefiners";
import {FoRFilterGroupOrder } from '../../utils/sortingLists';
import { Log } from '../../utils/logging';
import { getUrlParameter } from '../../utils/urlParamHelper';


const selectedProperties = [
    "Url",
    "Title",
    "language",
    "introtitle",
    "udirtitle",
    "innholdstype",
    "datoendret",
    "publisertdato",
    "description",
    "udirdescription",
    "laereplannavn",
    "laereplanaarstrinn",
    "HitHighlightedProperties",
    "HitHighlightedSummary",
    "rapportaar",
    "rapportaardate",
    "rapportinfo",
    "rapportnivaa",
    "rapportutgiver",
    "rapportinnholdstype",
    "stortdokumenttittel"
]

const properties = [
    "SourceName:Rapporter",
    "SourceLevel:SPSite"
]
const propertiesnoquery = [
    "SourceName:RapporterSortable",
    "SourceLevel:SPSite"
]

export async function getResults(query: string, pageNumber: number, refiners?: IRefiners[]) {
    //Getting different search url based on which environment we currently are in
    const baseUrl = getBaseSearchURL();

    //Setting default query to be all items
    let queryText = query !== "" ? query : "*";
    queryText = RemoveSpecialCharsFromQuery(queryText);

    let selectedPropertiesString = encodeURI(selectedProperties.join(','));
    let propertiesString = encodeURI(properties.join(','));
    let queryString = encodeURI(`${baseUrl}/_api/search/query?querytext='${queryText}'`);
    let startRow = (pageNumber - 1) * 10;
    let refinementFilter = encodeURI(generateRefinementFilters(refiners));

    // Get sort parameter from URL
    const sortByParam = getUrlParameter('sortby');
    let sortlist;
    
    if (sortByParam === 'date-desc') {
        sortlist = "datoendret:descending";
    } else if (sortByParam === 'date-asc') {
        sortlist = "datoendret:ascending";
    } else if (sortByParam === 'relevans') {
        sortlist = undefined; // Use default relevance ranking
    }
    if ((queryText === null || queryText === "" || queryText === "*") && sortlist !== "Title:ascending") {
        // Default: sort by date when no search query
        Log("Changing sortlist to datoendret:descending");
        sortlist = "datoendret:descending";
        propertiesString = encodeURI(propertiesnoquery.join(','));
    }
    
    queryString += `&selectproperties='${encodeURIComponent(selectedPropertiesString)}'`
    queryString += `&trimduplicates=false`
    queryString += `&culture=1044`
    queryString += `&enablequeryrules=true`
    queryString += `&processbestbets=true`
    queryString += generateRefinersString();
    queryString += refinementFilter;
    queryString += `&properties='${propertiesString}'`
    queryString += `&hithighlightedproperties='Title,description'`
    queryString += `&clienttype='AllResultsQuery'`
    if(sortlist){
        queryString += `&sortlist='${sortlist}'`;
    }
    queryString += `&startrow=${startRow}`;
    let response;
    //if(baseUrl === "https://udirsok-dev.udir.no" || baseUrl === "https://qa-sok.udir.no" || baseUrl === "https://sok.udir.no"){
    if(false){    
        //if (queryText === null || queryText === "" || queryText === "*"){
        //    queryString += `&QueryTemplatePropertiesUrl='spfile://webroot/queryparametertemplate-RapporterSortable.xml'`;
        //}else{
        //    queryString += `&QueryTemplatePropertiesUrl='spfile://webroot/queryparametertemplate-Rapporter.xml'`;
        //}
        queryString += `&QueryTemplatePropertiesUrl='spfile://webroot/queryparametertemplate-Rapporter.xml'`;
        const digest = await getDigest(baseUrl);
        Log("using queryparametertemplate-Rapporter.xml");
        response = await fetch(queryString, {
            headers: {
                'Accept': 'application/json',
                'X-RequestDigest': digest
            }
        });
    }else{
        response = await fetch(queryString, {
            headers: {
                'Accept': 'application/json'
            }
        });
    }
    let results = await response.json();
    let prossesedResults = GetRESTData(results, queryString, processRefiners);
    Log(prossesedResults)
    return prossesedResults;
}


export function generateRefinementFilters(refiners: IRefiners[] | undefined) {
    if(!refiners) {
        return "";
    }
    let refinerStrings: string[][] = [];
    refiners.forEach(refiner => {
        let checkedRefinerValues = refiner.Entries.filter(refinerValue => refinerValue.checked);
        let checkedRefinerStrings = checkedRefinerValues.map(val => `${refiner.Name}:${val.RefinementToken}`)
        refinerStrings.push(checkedRefinerStrings);
    });
    refinerStrings = refinerStrings.filter(list => list.length > 0);

    if(refinerStrings.length  === 0) {
        return "";
    } else if(refinerStrings.length === 1) {
        return `&refinementFilters='${mapRefinersToStrings(refinerStrings[0])}'`;
    } else {
        return `&refinementFilters='AND(${refinerStrings.map( refinerString => mapRefinersToStrings(refinerString)).join(',')})'`
    }

}

function mapRefinersToStrings(refinerElementStrings) {
    if(refinerElementStrings.length === 0) {
        return "";
    } else if(refinerElementStrings.length === 1) {
        return `${refinerElementStrings[0]}`;
    } else {
        return `OR(${refinerElementStrings.join(',')})`
    }
}

function processRefiners(searchRefiners) {
    if (null === searchRefiners) return null;
    let refiners = searchRefiners.Refiners
    let list:IRefiners[] = [];
    refiners.forEach(function (refiner) {
        if(refiner.Name === 'publisertdato' || refiner.Name === 'datoendret' || refiner.Name === 'rapportaar' || refiner.Name === 'rapportaardate') {
            list.push(processDateRefiners(refiner));
        } else {
            list.push({
                Name: refiner.Name,
                Entries: refiner.Entries
            });
        }
    });
    const sortedList = list.sort(sortRefinerGroups);
    return sortedList;
}

function processDateRefiners(refiner: any): IRefiners {
    const dateRegex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{7})?Z/
    const entries = refiner.Entries
        .filter(entry => entry.RefinementCount !== '0')
        .map(entry => {
        let date = entry.RefinementName.match(dateRegex)[0];
        const year = date.slice(0,4);
        if(entry.RefinementName.indexOf('Before') !== -1) {
            entry.RefinementName = `Før ${year}`;
        } else if(entry.RefinementName.indexOf('later') !== -1) {
            entry.RefinementName = `${year}`;
        } else {
            entry.RefinementName = year;
        }
        return entry
    });
    return {
        Name: refiner.Name,
        Entries: entries.reverse()
    };
}

function generateRefinersString(){
    // Example refinersString: `&refiners='rapportnivaa(sort=name/ascending)%2crapportutgiver(sort=name/ascending)%2crapportaardate(discretize%3Dmanual%2F2010-01-01%2F2011-01-01%2F2012-01-01%2F2013-01-01%2F2014-01-01%2F2015-01-01%2F2016-01-01%2F2017-01-01%2F2018-01-01%2F2019-01-01%2F2020-01-01%2F2021-01-01)'`
    var refinersString = "";
    refinersString += `&refiners='`;
    refinersString += `rapportinnholdstype(sort=name/descending)%2c`;
    refinersString += `rapportnivaa(sort=name/ascending)%2c`;
    refinersString += `rapportutgiver(sort=name/ascending)%2c`;
    refinersString += `rapportaardate(discretize%3Dmanual%2F`;
    var currentYear = (new Date()).getFullYear();
    for (let i = -20; i < 1; i++) {
        // Generating 20 "YYYY" filter tokens + 1 "Før YYYY" filter token
        refinersString += (currentYear+i).toString() + `-01-01%2F`;
    }
    refinersString = refinersString.slice(0,-3); // Removing %2F at end of string
    refinersString += `)'`;
    return refinersString;
}



function sortRefinerGroups(a: IRefiners, b: IRefiners) {
    return FoRFilterGroupOrder.indexOf(a.Name) - FoRFilterGroupOrder.indexOf(b.Name);
}
